Backbone = require 'backbone'

require './tips_input'
require './tip_submitter'

class TipsFrontendBuilder
  @build: (csrfToken, placeId, pageId, tipCount, offset, maxTipLength, minTipLength, hasPreviousTip) ->

    tipEvents = _.extend({}, Backbone.Events)

    UserTipOwnershipModel = Backbone.Model.extend()
    userTipOwnershipModel = new UserTipOwnershipModel(userHasTips: hasPreviousTip)

    tipSubmitter = new Groupon.TipSubmitter({
      csrf: csrfToken,
      placeId: placeId
    })

    mainTipsInputController = new Groupon.TipsInput({
      $el: $('.tips-module .tip-sharing-container')
      placeId
      tipSubmitter
      tipEvents
      userTipOwnershipModel
      minTipLength
    })

    new Groupon.Tips({
      el: '.tips-module'
      csrf: csrfToken
      offset: offset
      placeId
      tipCount
      maxTipLength
      minTipLength
      tipEvents
      userTipOwnershipModel
    })

$ ->
  $el = $('.tips-module')
  return unless $el.length > 0

  place = $('.mpp-container').data()
  tipsConfig = $el.data()
  csrfToken = $('meta[name=csrf-token]').attr('content')

  Groupon.TipsFrontendBuilder.build(
    csrfToken,
    place.placeId,
    tipsConfig.pageTips,
    tipsConfig.totalTips,
    tipsConfig.offset
    tipsConfig.maxTipLength,
    tipsConfig.minTipLength,
    tipsConfig.hasPreviousTip
  )

Groupon.TipsFrontendBuilder = TipsFrontendBuilder
